// @flow
import React from "react";
import { connect } from "react-redux";
import { useI18n } from "@quantum/i18n";
import SelecaoIndicesEBenchmarksPersonalizados from "../indice/SelecaoIndicesEBenchmarksPersonalizados";
import {
  type ActionCreator,
  selecionarBenchmark,
  selecionarPrimeiroBenchmark,
  getBenchmarkSelecionado,
} from "../../../../state";

type Prop = {
  benchmarkSelecionado: string,
  datasBenchmarkSelecionado: string,
  selecionarBenchmark: ActionCreator,
  selecionarPrimeiroBenchmark: ActionCreator,
};

function SelecaoBenchmark({
  benchmarkSelecionado,
  selecionarPrimeiroBenchmark,
  datasBenchmarkSelecionado,
  selecionarBenchmark,
}: Prop) {
  const { translate } = useI18n();

  return (
    <div className="ConfiguracaoMedida">
      <SelecaoIndicesEBenchmarksPersonalizados
        labelSelecao={translate("maiusculas.benchmark")}
        indiceSelecionado={benchmarkSelecionado}
        onChange={selecionarBenchmark}
        selecionarPrimeiroIndice={selecionarPrimeiroBenchmark}
        selecionarIndice={selecionarBenchmark}
      />
    </div>
  );
}

export default connect(
  state => ({
    benchmarkSelecionado: getBenchmarkSelecionado(state),
  }),
  { selecionarBenchmark, selecionarPrimeiroBenchmark }
)(SelecaoBenchmark);
